import { useFocalMap, getObjectPosition } from "../context/FocalMapContext";

/**
 * Drop-in replacement for <img> that respects an admin-set focal point
 * (via FocalMapContext) when the image is cropped by object-fit: cover.
 */
export default function SmartImage({ src, style, ...rest }) {
    const { map } = useFocalMap();
    const objectPosition = getObjectPosition(map, src);
    return (
        <img
            src={src}
            style={{ objectPosition, ...style }}
            {...rest}
        />
    );
}
